import * as yup from 'yup';

import type { IValidationField } from '../types';

export default function number({ label = '' }: IValidationField) {
  return yup.number().label(label);
}
